import GemMeterBaseRule from '../GemMeterBaseRule';
import { TITLE_IS_TOO_LONG } from '../../../constants/rulesConstants';

export default class TitleTooLongRule extends GemMeterBaseRule {
  static ruleId = TITLE_IS_TOO_LONG.id;

  static validate(selector: string) {
    let element = GemMeterBaseRule.getElement(selector);
    if (!element && selector.includes('.text-edit :first-child')) {
      const splitSelectors = selector.split(' ');
      element = GemMeterBaseRule.getElement(splitSelectors[0] + '.text-edit');
    }

    if (!element) {
      return true;
    }

    return element.textContent!.trim().length <= 70;
  }
}
